import { render, staticRenderFns } from "./IndexVideo.vue?vue&type=template&id=705411f8&scoped=true&"
import script from "./IndexVideo.vue?vue&type=script&lang=js&"
export * from "./IndexVideo.vue?vue&type=script&lang=js&"
import style0 from "./IndexVideo.vue?vue&type=style&index=0&id=705411f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705411f8",
  null
  
)

export default component.exports